webpackJsonp([184662623972074],{

/***/ 380:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jorge Mancheno, Product Designer","siteUrl":"https://jorgemancheno.com","email":"hello@jorgemancheno.com","dribbbleUrl":"https://dribbble.com/jorgemancheno","githubUrl":"https://github.com/jorgemancheno","twitterUrl":"https://twitter.com/jorgemancheno"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-21e253d88a5131278f1a.js